import { Currency } from '@nemuru-eng/js-api-client';
import { z } from 'zod';

export const getBlankDefaultValuesFromZodSchema = (schema: z.ZodTypeAny, currency?: Currency, key?: string): any => {
  if (schema instanceof z.ZodObject) {
    const shape = schema.shape;
    return Object.keys(shape).reduce((acc, key) => {
      acc[key] = getBlankDefaultValuesFromZodSchema(shape[key], currency, key);
      return acc;
    }, {} as Record<string, any>);
  }
  if (schema instanceof z.ZodString) {
    return '';
  }

  if (schema instanceof z.ZodNumber) {
    return 0;
  }

  if (schema instanceof z.ZodDate) {
    return null;
  }

  if (schema instanceof z.ZodArray) {
    return [];
  }

  if (schema instanceof z.ZodBoolean) {
    return false;
  }

  if (schema instanceof z.ZodNullable || schema instanceof z.ZodOptional) {
    return null;
  }

  if (key === 'currency') {
    return currency ?? Currency.EUR;
  }

  return undefined;
};
